export default __webpack_public_path__ + "static/media/x-logo-fill-white.4acea6ed.svg";